/**
 * @generated SignedSource<<15da1e2f458ffb04ae578278e3452ea0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_shippingFilters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedPersonalizedFilterToast_shippingFilters">;
  readonly " $fragmentType": "SbRespComponents_shippingFilters";
}>;
export type SbRespComponents_shippingFilters$key = ReadonlyArray<{
  readonly " $data"?: SbRespComponents_shippingFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_shippingFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespComponents_shippingFilters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters"
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};

(node as any).hash = "efe06964b9b07555da0ee972e23cecaa";

export default node;
